<script>
    import {createEventDispatcher} from "svelte";
    import {_} from "svelte-i18n";

    const dispatch = createEventDispatcher();

    export let saal;
    export let saalNumber;
</script>

<div class="saaltext-slider-item" on:click={() => dispatch("click")}>
    <img src={saal.image} alt={saal.name} class="saaltext-image"/>
    <div class="headline-xs saaltext-saal-number">
        {$_("hall")}
        {saalNumber}
    </div>
    <div class="headline-s saaltext-saal-name">
        {saal.name}
    </div>
    <img src="./images/icons/plus.svg" alt={$_("more")}/>
</div>

<style>
    .saaltext-slider-item {
        width: 218px;
        margin: 0 0px;
        cursor: pointer;
    }

    .saaltext-saal-number {
        margin-top: 8px;
        margin-bottom: 8px;
    }

    .saaltext-saal-name {
        margin-bottom: 8px;
        max-lines: 3;
        text-overflow: ellipsis;
        white-space: normal;
        word-break: break-word;
        padding-right: 80px;
    }

    .saaltext-image {
        width: 218px;
        max-height: 360px;
    }

    @media only screen and (min-width: 1440px) {
        .saaltext-image {
            width: 304px;
            max-height: 451px;
        }

        .headline-xs {
            font-size: 24px;
            line-height: 100%;
        }

        .saaltext-slider-item {
            width: 304px;
        }

        .saaltext-saal-number {
            font-size: 24px;
            line-height: 100%;
            letter-spacing: -0.02em;
        }

        .saaltext-saal-name {
            font-weight: 700;
            font-size: 40px;
            line-height: 100%;
            letter-spacing: -0.04em;
        }
    }
</style>
